export const LOAD_ASSETS: string = "LoadAssets";
export const UNLOAD_ASSETS: string = "UnloadAssets";
export const SHOW_LOAD_SCREEN: string = "ShowLoadScreen";
export const HIDE_LOAD_SCREEN: string = "HideLoadScreen";
export const STATE_TRANSITION_HALTED: string = "StateTransitionHalted";
export const STATE_TRANSITION_RESUME_FROM_HALT: string = "StateTransitionResumeFromHalt";
export const STATE_LOAD_STATE: string = "StateLoadState";
export const LOAD_SCREEN_HIDDEN: string = "LoadScreenHidden";

export const SHOW_POPUP: string = "ShowPopup";
export const HIDE_POPUP: string = "HidePopup";
export const HIDE_ALL_POPUPS: string = "HideAllPopups";
export const HIDE_TOPMOST_POPUP: string = "HideTopmostPopup";
export const HIDE_POPUP_COMPLETE: string = "HidePopupComplete";
export const HIDE_ALL_POPUPS_COMPLETE: string = "HideAllPopupsComplete";

export const PLAY_AUDIO: string = "PlayAudio";
export const LOAD_AUDIO: string = "LoadAudio";
export const LOAD_AUDIO_FROM_ASSET_MAP: string = "LoadAudioFromToken";
export const AUDIO_LOAD_ERROR: string = "AudioLoadError";

export const PLAY_CAPTION: string = "PlayCaption";
export const STOP_CAPTION: string = "StopCaption";

export const GAME_PAUSED: string = "GamePaused";
export const GAME_UNPAUSED: string = "GameUnpaused";

export const VOICEOVER_STARTED: string = "VoiceoverStarted";
export const VOICEOVER_ENDED: string = "VoiceoverEnded";

export const DRAG_BEGIN: string = "DragBegin";
export const DRAG_END: string = "DragEnd";
export const DRAGGABLE_SELECTED: string = "DraggableSelected";
export const DRAGGABLE_DESELECTED: string = "DraggableDeselected";

export const REGISTER_FOCUSABLE: string = "RegisterFocusable";
export const REGISTER_FOCUSABLES: string = "RegisterFocusables";
export const UNREGISTER_FOCUSABLE: string = "UnregisterFocusable";
export const UNREGISTER_FOCUSABLES: string = "UnregisterFocusables";
export const UNREGISTER_ALL_FOCUSABLES: string = "UnregisterAllFocusables";
export const CLEAR_FOCUS: string = "ClearFocus";
export const FORCE_FOCUS: string = "ForceFocus";
/** @deprecated */
export const RE_MAP_KEYBOARD: string = "ReMapKeyboard";
export const PUSH_KEYBOARD_LAYER: string = "PushKeyboardLayer";
export const POP_KEYBOARD_LAYER: string = "PopKeyboardLayer";
export const KEYBOARD_FORCE_NEIGHBOURS: string = "KeyboardForceNeighbours";
export const KEYBOARD_CLEAR_NEIGHBOURS: string = "KeyboardClearNeighbours";
/** @deprecated */
export const SET_KEYBOARD_AUTOMAP: string = "SetKeyboardAutomap";
export const SET_KEYBOARD_ENABLED: string = "SetKeyboardEnabled";
export const GET_KEYBOARD_STATUS: string = "GetKeyboardStatus";

export const KEYBOARD_FOCUS_BEGIN: string = "KeyboardFocusBegin";
export const KEYBOARD_FOCUS_END: string = "KeyboardFocusEnd";
export const KEYBOARD_REFOCUS: string = "KeyboardRefocus";

export const LANDSCAPE_ORIENTATION: string = "LandscapeOrientation";
export const PORTRAIT_ORIENTATION: string = "PortraitOrientation";
